// extracted by mini-css-extract-plugin
export default {"Wrapper":"OverlapItem_Wrapper__t5j8a"};